export default "__VITE_ASSET__eb7e1a0d__"